import { PSDConversionError } from '@app/manage-view/creative-converter/conversion-errors';
import { ISize, IPosition } from '@studio/domain/dimension';
import { Color } from 'ag-psd/dist/psd';

export enum PSDElementType {
    Unknown = 'unknown',
    Root = 'root',
    Layer = 'layer',
    Group = 'group',
    Text = 'text',
    Vector = 'vector',
}

export interface PSDElementTextData {
    text: string;
    color?: Color;
    font?: string;
    fontSize?: number;
}

export interface PSDElementVectorData {
    color?: Color;
}
export interface PSDElementLayerData {
    url: string; // base64 encoded
}

export interface PSDElementGroupData {
    opened: boolean;
    children?: PSDElement[];
}

export interface PSDElementRootData {
    children?: PSDElement[]; // tree structure of all layers
    flatChildren: PSDElement[]; // flat list of all layers
}

export interface PSDElementUnknownData {}

export type PSDElementData = PSDElementLayerData | PSDElementTextData | PSDElementVectorData | PSDElementGroupData | PSDElementRootData | PSDElementUnknownData;

export interface IPSDElement {
    id: string;
    type: PSDElementType;
    name: string;
    position: IPosition;
    size: ISize;
    thumbnail: string;
    hidden: boolean;
    opacity: number;
    error?: PSDConversionError;
}

export type PSDRootElement = IPSDElement & { type: PSDElementType.Root, data: PSDElementRootData };
export type PSDGroupElement = IPSDElement & { type: PSDElementType.Group, data: PSDElementGroupData };
export type PSDUnknownElement = IPSDElement & { type: PSDElementType.Unknown, data: PSDElementUnknownData };
export type PSDLayerElement = IPSDElement & { type: PSDElementType.Layer, data: PSDElementLayerData };
export type PSDTextElement = IPSDElement & { type: PSDElementType.Text, data: PSDElementTextData };
export type PSDVectorElement = IPSDElement & { type: PSDElementType.Vector, data: PSDElementVectorData };
export type PSDElement = PSDRootElement | PSDUnknownElement | PSDLayerElement | PSDTextElement | PSDVectorElement | PSDGroupElement;
